var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasTreeOrnaments = function SvgChristmasTreeOrnaments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.063 13.36a3.516 3.516 0 1 0 7.03 0 3.516 3.516 0 1 0-7.03 0m3.515-3.516V3.652M7.031 11.953V5.766m7.032 7.594h7.03M2.11 16.875a4.922 4.922 0 1 0 9.843 0 4.922 4.922 0 1 0-9.844 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.156 17.576c1.1-.016 1.058-1.406 2.17-1.406s1.12 1.406 2.24 1.406 1.125-1.406 2.24-1.406 1.125 1.406 2.243 1.406a1.15 1.15 0 0 0 .901-.438M.703 7.031l21.094-4.218M1.875 6.797 4.219 9.14m0-2.812 2.11-3.516m1.513 2.791 3.073 3.32m-.445-3.845 1.483-2.969m1.055 2.461 2.46 2.461m-.702-2.812L16.875.703m2.15 2.66 1.366-1.957m-1.366 1.957 2.069 1.559"
  })));
};
export default SvgChristmasTreeOrnaments;